const columnDataManuals = [
  {
    dataField: 'fileName',
    caption: 'Имя файла видеоинструкции',
    dataType: 'string',
    notVisible: true,
    allowSearch: false,
    allowFiltering: false
  },
  {
    dataField: 'manualNumId',
    caption: 'Id инструкции',
    dataType: 'string',
    notVisible: true,
    allowSearch: false,
    allowFiltering: false
  },
  {
    dataField: 'manualTitle',
    caption: 'Название инструкции',
    dataType: 'string',
    notVisible: false,
    allowSearch: true,
    allowFiltering: false
  },
  {
    dataField: 'orderIndex',
    caption: 'Порядковый номер',
    dataType: 'number',
    notVisible: true,
    allowSearch: false,
    allowFiltering: false
  },
  {
    dataField: 'maxIndex',
    caption: 'Максимальный номер',
    dataType: 'number',
    notVisible: true,
    allowSearch: false,
    allowFiltering: false
  }
];

export default columnDataManuals;
